
const CONTENT_RESTRICTION_RULE = {
    PROFILE_PUBLICATION_LIMIT : "PROFILE_PUBLICATION_LIMIT",
    PROFILE_COLLECTIONS_LOCKED : "PROFILE_COLLECTIONS_LOCKED",
    VIDEO_DURATION_LIMIT : "VIDEO_DURATION_LIMIT"
}

export default CONTENT_RESTRICTION_RULE;